import { CheckIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Checkbox,
  Heading,
  HStack,
} from "@chakra-ui/react";
import { NotificationPreferenceCategoryAccordionProps } from "@ui/application/forms";
import { PreferenceSubcategory } from "./preference-subcategory";

export const PreferenceCategory = (
  props: NotificationPreferenceCategoryAccordionProps,
) => {
  const {
    title,
    id,
    allSelected,
    subcategories,
    handleChange,
    handleSelectAll,
  } = props;
  return (
    <AccordionItem bg="gray.100" border="none" borderRadius="3xl">
      <>
        <AccordionButton
          py={{
            base: "5",
            md: "8",
          }}
          pl="8"
          borderRadius="3xl"
        >
          <HStack flex="1">
            <Checkbox
              name={id}
              size="lg"
              colorScheme="green"
              aria-label={"Subscribe to all " + title + " Notifications"}
              defaultChecked={allSelected}
              checked={allSelected}
              icon={<CheckIcon />}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleSelectAll(e)
              }
            />
            <Heading textColor="black" fontSize="lg">
              {title}
            </Heading>
          </HStack>
          <AccordionIcon color="black" boxSize="6" />
        </AccordionButton>
        <AccordionPanel>
          <Accordion allowMultiple defaultIndex={[]}>
            {subcategories.map((subcategory, idx) => (
              <PreferenceSubcategory
                key={subcategory.topic + idx}
                {...subcategory}
                category={id}
                handleChange={handleChange}
              />
            ))}
          </Accordion>
        </AccordionPanel>
      </>
    </AccordionItem>
  );
};
